//import { User } from './../models/user.model';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ValueParserParams } from 'ag-grid-community';
import * as moment from 'moment';
import { Observable,BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  orgDepartmentList=[]; 
  privileges = new BehaviorSubject<any>(null);

  //to share medical file id among components.
  private medicalFileIdSource = new BehaviorSubject(null);
  medicalFileId$ = this.medicalFileIdSource.asObservable();
  private medicalFileStatusSource = new BehaviorSubject(null);
  medicalFileStatus$ = this.medicalFileStatusSource.asObservable();
  private userProfileIdSource = new BehaviorSubject(null);
  userProfileId$ = this.userProfileIdSource.asObservable();
  private userOrgmsIdSource = new BehaviorSubject(null);
  userOrgsmId$ = this.userOrgmsIdSource.asObservable();
  private userPrivileges = new BehaviorSubject<any>(null);
  userPrivilages$ = this.userPrivileges.asObservable();
  private userMenus = new BehaviorSubject<any>(null);
  userMenus$ = this.userMenus.asObservable();
  authenticated: boolean;
  masterPrvilage: any;
  isPrivilege: boolean;

  constructor(private http: HttpClient,private datePipe: DatePipe) { }
  /* private aisKey = new BehaviorSubject<String>(new String());
  currentMessage = this.messageSource.asObservable();
  currentKey = this.aisKey.asObservable();
  navigationData: any;
  authenticated : boolean = false;

  constructor() { }

  changeMessage(user: User) {
    this.messageSource.next(user);
  } */

  /* changeAisKey(key: String) {
    this.aisKey.next(key);
  }

  setNavigationData(data: any) {
    this.navigationData = {};
    this.navigationData = data;
  }
 */

   // Service message commands
  nextMedicalFiledId(id: number) {
    this.medicalFileIdSource.next(id);
  }
  medicalFileStatus(status: String) {
    this.medicalFileStatusSource.next(status);
  }
  setUserProfileId(id: number) {
    this.userProfileIdSource.next(id);
  }
  setUserOrganismId(id: number) {
    this.userOrgmsIdSource.next(id);
  }
  /* setUserPrivilages(privilage:any[]) {
    this.http.get(CommonConstants.env + 'api/user/privilages').subscribe(response => {
      this.masterPrvilage = response['result'];
      let userPrivilage = [];
      for (let item of privilage) {
        let master = this.masterPrvilage.filter(master => master.privilageId === item.id.privilageId)
        let data = {
          priivilageId: item.id.privilageId,
          privilageName: master ? master[0].privilageName : null
        }
        userPrivilage.push(data);
      }
      this.userPrivileges.next(userPrivilage);
    })

  }
  setUserMenus(menus:any[]) {
    this.userMenus.next(menus);
  } */
  hasPrivilege(privilege: string){
   /*  this.userPrivileges.subscribe(res => {
      if (!res) {
        this.setUserPrivilages(<any>localStorage.getItem(CommonConstants.USER_PRIVILAGE));
      }
    })
    this.userPrivileges.subscribe(res => {
      let exist = res.filter(item => item.privilageName === privilege);
      if (exist != null && exist.length > 0) {
        this.isPrivilege = true;
        return this.isPrivilege;
      }
    }) */
    if (!this.privileges.value) {
      this.privileges.next(JSON.parse(localStorage.getItem(CommonConstants.USER_PRIVILAGE)));
    }
    this.privileges.subscribe(res => {
      let exist = res.filter(item => item.privilageName === privilege);
      if (exist != null && exist.length > 0) {
        this.isPrivilege = true;
        return this.isPrivilege;
      }
    })
    return this.isPrivilege;
  } 
  /**
    * Update the duplicate item in the list, compare the item before push.
    * @param compareId value to compare
    * @param itemArr   item array
    * @param compareAttr attribute against the value need to be compared.
    * @param newItem new item to be replaced.
    */
  updateDuplicateRecord(compareId, itemArr, compareAttr, newItem) {
    var index = itemArr.findIndex(item => item[compareAttr] === compareId);
    if (index > -1) {
      itemArr[index] = newItem;
      if(itemArr[index]["staRecCode"]!='A'){
        itemArr.splice(index, 1);
      }
      
    } else {
      if(newItem["staRecCode"]=='A'){
       itemArr.push(newItem);
      }
    }
    return [...itemArr];
  }

  getPrivilages() {
    /* this.http.get<any[]>('url').pipe(first()).subscribe(
      (res) => {
        this.privileges.next(res);
      }
    ); */
    this.privileges.next(JSON.parse(localStorage.getItem(CommonConstants.USER_PRIVILAGE)));
  }

  public ageFromDateOfBirthday(dateOfBirth: any): number {
    dateOfBirth = moment(dateOfBirth, "DD-MM-YYYY HH:mm").toDate();
    let age = 0;
    if (dateOfBirth) {
      const today = new Date();
      const birthDate = new Date(dateOfBirth);
      age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
    }
    return age;
  }

  newPublishSetter(params: ValueParserParams) {
    if (params.newValue >= 0) {
      params.data[params.colDef.field] = params.newValue;
      if (isNaN(params.newValue)) {
        return false;
      }
      return true;;
    }
  }
  getInternationPhoneFormat(params:any){
    let intlNumber=null;
      if (params) {
        let splitted = params.split("/");
        if (splitted.length > 2) { 
        intlNumber = {
          "countryCode": splitted[0],
          "dialCode": splitted[1],
          "e164Number": splitted[1] + splitted[2],
          "internationalNumber": splitted[1] + ' ' + splitted[2],
          "nationalNumber": splitted[2],
          "number": splitted[2]
        }
        return intlNumber;
      }
    }
    return intlNumber;
  }
  setPhoneNumberfrmInternation(phone){
    if(phone){
      let intlNumber=phone.countryCode+ '/'+phone.dialCode+ '/'+phone.nationalNumber;
     return intlNumber;
    }
  }
  setOrganismDepartment(departmentList){
    this.orgDepartmentList=departmentList;
  }
  getOrganismDepartment(){
    return this.orgDepartmentList;
  }
  getDateFormat(selectedDate){
    //return this.datePipe.transform(selectedDate, 'dd-MM-yyyy HH:mm');
    return moment(selectedDate,'DD-MM-YYYY HH:mm').format('DD-MM-YYYY HH:mm');
  }
  setAuthenticated(val: boolean) {
    this.authenticated = val;
  }
  autoSizeAll(gridColumn) {
    var allColumnIds = [];
    gridColumn.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    gridColumn.autoSizeColumns(allColumnIds, false);
  }
  cleanupRows(gridName: string) { 
    const notesColumns = ['mednoDtDate', 'mednoVaContent', 'mednoVaTitle'];
    const opdColumns = ['medocDtPrescription', 'medocDtRealisation', 'medocVaCode', 'medocVaDescription', 'medocVaOperator', 'statuCode'];

    let targetRowData = [];
    let targetColumns = [];
    let emptyRowsIndex = [];
    
    switch(gridName){
      case 'notes': {
       // targetRowData = this.notesRowData;
        targetColumns = notesColumns;
        break;
      }

      case 'opdCare': {
       // targetRowData = this.opdCareRowData;
        targetColumns = opdColumns;
        break;
      }
      default: return;
    }

    targetRowData.forEach((row, index) => {
      let empty = true;
      targetColumns.map(key => {
        if(row[key]){
          empty = empty && false;
        }
      })
      if(empty){
        emptyRowsIndex.push(index);
      }
    })

    emptyRowsIndex.slice().reverse().forEach(index => {
      targetRowData.splice(index, 1);
    })

  }
}

